import Configuration from '../../utils/config';
import AxiosInstance from '../../interceptor/http-intercepor';
import Axios from 'axios';
import { alertService } from '../../components/toaster/alert.service';
import { loaderService } from '../../components/loader/loader.service';

class EnquiryService {
  constructor() {
      this.config = new Configuration();
  }
  async submitEnquiry(enquiryObj) {
    loaderService.show(true);
    const userId= localStorage.getItem('userId');
    enquiryObj.userId=userId;
   
    // companyObj.rfpId= companyObj.rfpId? companyObj.rfpId : '5f5b95af2f5dd3cde517e762';
    const url = this.config.baseUrl + this.config.submitEnquiry;
   
    const config = {
        headers: {
            'content-type': 'application/json',
        }
    }
    return AxiosInstance.post(url, enquiryObj, config)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        this.handleError(error);
      });
  }
}
export default EnquiryService;